// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

export default {
  Taxonomy: {
    EditNode: 'Edit ingredient',
    Save: 'Save',
    Saved: 'Ingredient updated.',
    Active: 'Active (uncheck to archive)',
    Archived: 'Archived',

    Title: 'Ingredients',
    Subtitle: 'Explore classes and their validated annotations, then extend the ingredient tree.',
    Search: 'Search by name or code',
    Restaurant: 'Restaurant',
    AllRestaurants: 'All my restaurants',
    Project: 'Project',
    AllProjects: 'All projects',
    AnnotationType: 'Annotation type',
    BboxOnly: 'BBox',
    MaskOnly: 'Masks',
    BothTypes: 'BBox and masks',
    Depth: 'Depth',
    Level: 'Level {{level}}',
    Reset: 'Reset view',
    Refresh: 'Refresh',
    Loading: 'Loading taxonomy',
    MapLabel: 'Taxonomy map',
    NoResults: 'No nodes match this search.',
    Empty: 'The taxonomy is empty. Import the reference taxonomy to get started.',
    NoBranches: 'No branches yet. Add a node under the root.',
    LoadError: 'Unable to load the ingredient tree.',
    StatsError: 'Annotation counts are unavailable.',
    CountsUnavailable: 'Annotations: —',
    Retry: 'Retry',
    Classes_one: '{{count}} descendant class',
    Classes_other: '{{count}} descendant classes',
    Annotations_one: '{{formatted}} validated annotation',
    Annotations_other: '{{formatted}} validated annotations',
    CountHelp:
      'Classes: active selectable descendants, excluding the current node. Annotations: validated assignments on the node and its active descendants, within the selected restaurant, project and annotation type. These counts are not unique images.',
    Expand: 'Expand',
    Collapse: 'Collapse',
    Details: 'Node details',
    SelectNode: 'Select a node to view its definition, path and counts.',
    NoDefinition: 'No definition provided.',
    AnnotationDetails: 'Validated annotation breakdown',
    ValidatedAnnotations: 'Validated annotations',
    Direct: 'Node only',
    Subtree: 'Node and descendants',
    BboxAssignments: 'Bbox assignments',
    Masks: 'Masks',
    AddNode: 'Add a node',
    AddChild: 'Add a child',
    Parent: 'Parent node',
    Name: 'Name',
    Code: 'Code',
    Definition: 'Definition',
    Selectable: 'Selectable for training',
    NotSelectable: 'Not selectable',
    CodeHelp: 'Unique immutable code: uppercase letters, digits and underscores, starting with a letter.',
    NameInvalid: 'Enter a name between 1 and 256 characters.',
    CodeInvalid: 'Use 1 to 128 characters: A–Z, 0–9 and _, starting with a letter.',
    CodeExists: 'This code already exists, possibly on an archived node.',
    ParentRequired: 'Select an existing active parent.',
    ImportRequired: 'Import the ingredient tree before adding nodes.',
    SaveError: 'Unable to create the node. Check your access and try again.',
    Created: 'The node was created.',
    Cancel: 'Cancel',
    Create: 'Create',
    Saving: 'Creating…',
  },
  PipelineComparisons: {
    ScoreUnavailable: 'score unavailable',
    Pair: 'Pair {{pair}} · IoU {{iou}}',
    Unmatched: 'No match',
    BoxCount: '{{count}} boxes',
    BoxCount_one: '{{count}} box',
    BoxCount_other: '{{count}} boxes',
    Reload: 'Reload',
    ImageLoadError: 'Unable to load the image. Reload to refresh its access URL.',
    NoResult: 'No results yet.',
    PreviousImage: 'Previous',
    NextImage: 'Next',
    ImagePosition: 'Image {{current}} / {{total}}',
    LoadingImages: 'Loading…',
    ImageThumbnails: 'Image thumbnails',
    SelectImage: 'Image {{id}} — {{status}}',
    OpenAnnotationWorkspace: 'Open this image in Annotation Workspace ↗',
    ImageNavigationHint: 'Select a thumbnail or use the ← → keys to browse the filtered images.',

    Candidate: 'Candidate pipeline',
    NewComparison: 'New comparison',
    SavedRuns: 'Saved runs',
    NoRuns: 'No saved runs. Create a comparison to get started.',

    Comparison: 'Comparison',
    Disagreement: 'Disagreement',
    Title: 'Pipeline comparisons',
    View: 'Displayed stages',
    Detection: 'Detection',
    Classification: 'Vrac classification',
    AllStages: 'All stages',
    reference: 'Pipeline A — reference',
    candidate: 'Pipeline B — candidate',
    StoredReference: 'Saved results',
    DetectionModel: 'Detector key',
    ClassificationModel: 'Vrac classifier key',
    Threshold: 'Vrac threshold (strict)',
    ActualModel: 'Actual detector',
    SharedDetection: 'Shared detection — no additional call',
    Products: 'Products',
    Evidence: 'Availability',
    Probabilities: 'Probabilities',
    ProbabilityMeaning:
      'P(vrac) is a class probability. Metrics measure agreement and disagreement without validated ground truth.',
    ModelChanged: 'The model or its parameters changed. This run is blocked; create a new run to continue.',
    Restaurant: 'Restaurant',
    Name: 'Run name (optional)',
    StartDate: 'Start date',
    EndDate: 'End date',
    Limit: 'Maximum images',
    Mode: 'Mode',
    StoredMode: 'Saved vs candidate',
    PipelineMode: 'Pipeline A vs pipeline B',
    FullPipeline:
      'Every image executes detection and vrac classification. Views only change the display. Retention: 30 days.',
    Create: 'Create and start',
    Run: 'Run',
    Stop: 'Stop queue',
    Expired: 'This run has expired.',
    Progress: '{{completed}} / {{total}} images completed · {{failed}} failed · {{pending}} pending',
    AgreementCounts:
      '{{comparable}} comparable pairs · {{disagreements}} disagreements · {{unavailable}} unavailable or non-comparable',
    MeanDelta: 'Mean P(vrac) difference',
    Processing: 'Mean duration',
    Resume: 'Resume',
    Retry: 'Retry this image',
    Delete: 'Delete',
    DeleteConfirm: 'Delete this run and its experimental results?',
    Cancel: 'Cancel',
    Difference: 'Differences',
    Status: 'Status',
    Sort: 'Sort',
    IoU: 'Filter IoU threshold',
    Image: 'Image',
    NoImages: 'No images match these filters.',
    all: 'All',
    different: 'Any detection difference',
    more: 'More candidate boxes',
    fewer: 'Fewer candidate boxes',
    count: 'Different counts',
    low_iou: 'Low IoU',
    classification_disagreement: 'Classification disagreement',
    classification_unavailable: 'Classification unavailable',
    pending: 'Pending',
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
    chronological: 'Chronological',
    count_delta: 'Count difference',
    min_iou: 'Minimum IoU',
    available: 'Available',
    missing: 'Missing',
    stale: 'Stale',
    not_applicable: 'Not applicable',
    not_comparable: 'Not comparable',
    comparable: 'Comparable',
    stage_detection: 'Detection',
    stage_vrac: 'Vrac classification',
    stage_total: 'Total',
  },
  ProductCatalog: {
    Title: 'Product Catalog',
    Categories: {
      indus_food: 'Industrials / Yogurts',
      drink: 'Drinks',
      fruit: 'Fruits',
      snack: 'Snacks',
    },
    Search: 'Search name, brand or ID',
    SearchMinimum: 'Enter at least 3 characters or a product ID.',
    SearchTooLong: 'Search must contain at most 255 characters.',
    Brand: 'Brand',
    HasAnnotatedImages: 'Has annotated images',
    All: 'All',
    Yes: 'Yes',
    No: 'No',
    NoBrand: 'No brand',
    AnnotatedImages_one: '{{count}} annotated image',
    AnnotatedImages_other: '{{count}} annotated images',
    Restaurants: 'Restaurants using this product',
    RestaurantsTitle: 'Restaurants using {{name}}',
    RestaurantsScope: 'Only active restaurants assigned to your account are shown.',
    NoRestaurants: 'No active assigned restaurants use this product.',
    RestaurantsError: 'Could not load restaurant usage.',
    BrandsError: 'Could not load brands.',
    LoadError: 'Could not load products.',
    NoProducts: 'No products match these filters.',
    ProductCount_one: '{{count}} product',
    ProductCount_other: '{{count}} products',
    RestaurantSearch: 'Search restaurant name or ID',
    NoRestaurantMatches: 'No active assigned restaurants match your search.',
    LoadingRestaurants: 'Loading restaurants…',
    LoadMoreRestaurants: 'Load more restaurants',
    SortBy: 'Sort by',
    SortOptions: {
      default: 'Default',
      name_asc: 'Name: A–Z',
      name_desc: 'Name: Z–A',
      id_asc: 'ID: low to high',
      id_desc: 'ID: high to low',
      annotated_images_desc: 'Annotated images: high to low',
      annotated_images_asc: 'Annotated images: low to high',
    },
    ItemsPerPage: 'Items per page',
    Retry: 'Retry',
    Close: 'Close',
    Edit: 'Edit',
    Actions: 'Actions',
    NoImage: 'No image for this product.',
    ImageError: 'Could not load the image.',
  },
  'Open in TrayHealth': 'Open in TrayHealth',
  HealthAnnotationsPairViewer: {
    Settings: 'Settings',
    Show_Masks: 'Show Masks',
    Show_Labels: 'Show Labels',
    Waiting_Initial_Photo: 'Waiting for initial photo',
    Waiting_Completion_Photo: 'Waiting for completion photo',
    No_Image: 'No Image',
    Meal: 'Meal:',
    Client: 'Client:',
    Time: 'Time:',
    Mask_Opacity: 'Mask Opacity',
    Pair_View: 'Pair View',
    Single_View: 'Single View',
    Close_Settings: 'Close settings',
    Visibility_Settings: 'Visibility Settings',
    Incomplete_Pair: 'Incomplete Pair',
    Loading_Image: 'Loading image...',
  },
  Navbar: {
    taxonomy: 'Ingredients',
    product_catalog: 'Product Catalog',
    catalog_industrials: 'Industrials / Yogurts',
    catalog_drinks: 'Drinks',
    catalog_fruits: 'Fruits',
    catalog_snacks: 'Snacks',

    selfcheckout_subheader: 'Self-Checkout',
    dashboard: 'Dashboard',
    restaurant_products: 'Products',
    menus: 'Menus',
    reports: 'Reports',
    product_tools: 'Products Tools',
    api_sandbox: 'API Sandbox',
    health_subheader: 'Health',
    tools_subheader: 'Tools',
    correction: 'Correction',
    merge: 'Merge',
    edit: 'Edit',
    create: 'Create',
    annotations: 'Annotations',
    workspace: 'Annotation Workspace',
    legacy_annotations: 'Legacy annotations',
    evaluation: 'Evaluation',
    pipeline_comparisons: 'Pipeline comparisons',
    ingredients_check: 'Ingredient Check',
    ingredients_crop: 'Ingredient Crop',
    admin_subheader: 'Administration',
    users: 'Users',
    list: 'List',
    restaurants: 'Restaurants',
    itentification_token: 'Identification (Token)',
    visualization: 'Visualization',
    reporting: 'Reporting',
    summary_csi: 'Summary CSI',
    api_documentation: 'API Documentation',
    clients: 'Clients',
    'menus management': 'Menus Management',
    ciqual: 'Ciqual',
    'dish profiles': 'Dish profiles',
    ingredients_mapping: 'Ingredients Mapping',
  },
  IngredientProductMappings: {
    Page_Title: 'Ingredient mappings',
    Heading: 'Ingredient mappings',
    Actions: {
      Create: 'Add mapping',
    },
    Table: {
      Ingredient: 'Ingredient',
      Product: 'Product',
      Scope: 'Scope',
      Restaurant: 'Restaurant',
      Restaurant_Product: 'Restaurant product',
    },
    Badges: {
      Fallback: 'Fallback',
      Additive: 'Additive',
    },
    Scope: {
      all: 'All scopes',
      global: 'Global',
      restaurant: 'Restaurant override',
    },
    Toolbar: {
      Search_Placeholder: 'Search ingredient, product, or restaurant product...',
      Scope_Label: 'Scope',
      Restaurant_Context: 'Restaurant override context: {{restaurant}}',
      Restaurant_Missing: 'Select a restaurant to view and manage restaurant override mappings.',
      No_Restaurant: 'No restaurant selected',
    },
    Dialog: {
      Create_Title: 'Create ingredient mapping',
      Edit_Title: 'Edit ingredient mapping',
      Create_Action: 'Create mapping',
      Save_Action: 'Save changes',
      Scope_Label: 'Mapping scope',
      Ingredient_Label: 'Ingredient',
      Product_Label: 'Canonical product',
      Restaurant_Product_Label: 'Restaurant product',
      Product_Search_Hint: 'Start typing to search products',
      Product_Search_Minimum: 'Type at least {{count}} characters',
      Product_Search_Error: 'Unable to search products',
      No_Products: 'No products found',
      Restaurant_Context: 'Restaurant override target: {{restaurant}}',
      Derived_Product: 'The canonical product will be derived from {{product}}.',
      Show_Conflict: 'Show existing mapping',
      Fallback_Label: 'Fallback product',
      Fallback_Helper: 'Used when the classifier parent is not compatible with any target.',
      Additive_Label: 'Additive ingredient',
      Additive_Helper: 'This setting applies globally to the ingredient and adds detections to incompatible parents.',
    },
    Delete: {
      Title: 'Delete ingredient mapping',
      Description: 'Delete the mapping between {{ingredient}} and {{product}}?',
      Confirm: 'Delete mapping',
      Fallback_Required: 'Choose another fallback product before deleting this mapping.',
    },
    Snackbar: {
      Create_Success: 'Ingredient mapping created successfully',
      Update_Success: 'Ingredient mapping updated successfully',
      Delete_Success: 'Ingredient mapping deleted successfully',
      Save_Error: 'Error while saving the ingredient mapping',
      Conflict_Error: 'The mapping configuration conflicts with the selected scope.',
      Delete_Error: 'Error while deleting the ingredient mapping',
      Load_Error: 'Error while loading ingredient mappings',
    },
    Rows_Per_Page: 'Mappings per page',
    Dense: 'Dense',
  },
  AnnotationWorkspace: {
    Ingredient: 'Ingredient',
    AnnotationChanges: 'Annotation changes',
    ModifiedBy: 'Modified by',
    ModifiedBetween: 'Modified between',
    ClearModificationDates: 'Clear modification dates',
    UnableToLoadHistoryUsers: 'Unable to load users from annotation history.',

    DisplayOptions: 'Display options',
    ShowIngredientsInBoxList: 'Show ingredients in box list',
    CollapseInspector: 'Collapse inspector',
    ExpandInspector: 'Expand inspector',
    MultipleRestaurants: 'Multiple restaurants',
    SelectRestaurant: 'Select a restaurant',
    DetectionScore: 'Detection score',
    IngredientDetectionScore: 'Ingredient detection score',
    MinimumScore: 'Min',
    MaximumScore: 'Max',
    ApplyScores: 'Apply scores',
    InvalidScore: 'Enter a percentage from 0 to 100',
    InvalidScoreRange: 'Max must be at least Min',
    UnableToLoadFilterOptions: 'Unable to load filter options',
    PageTitle: 'Annotation Workspace',
    LegacyPageTitle: 'Annotations: Legacy images',
    PageHeading: 'Annotation Workspace',
    Dashboard: 'Dashboard',
    Annotations: 'Annotations',
    AnnotationWorkspace: 'Annotation Workspace',
    Images: 'Images',
    Filters: 'Filters',
    Close: 'Close',
    Refresh: 'Refresh',
    AutoRefresh: 'Auto refresh',
    AutoRefreshOff: 'Off',
    AutoRefreshSeconds: '{{count}} s',
    AutoRefreshMinutes: '{{count}} min',
    UnableToRefreshAnnotations: 'Unable to refresh annotations',
    Save: 'Save',
    ResultRail: 'Result rail',
    NewestFirst: 'Newest first',
    OldestFirst: 'Oldest first',
    ChangeImageOrder: 'Change image order',
    Workspace: 'Workspace',
    Inspector: 'Inspector',
    Context: 'Context',
    Details: 'Details',
    Ingredients: 'Ingredients',
    History: 'History',
    Tickets: 'Tickets',
    Restaurant: 'Restaurant',
    FromDate: 'From date',
    ToDate: 'To date',
    DateRange: 'Date range',
    SelectStartDate: 'Select a start date',
    SelectEndDate: 'Select an end date',
    Apply: 'Apply',
    Cancel: 'Cancel',
    Product: 'Product',
    ObjectClass: 'Object class',
    ImageValidation: 'Image validation',
    Enrollment: 'Enrollment',
    TicketPresence: 'Ticket presence',
    AnnotationPresence: 'Bounding box presence',
    IngredientPresence: 'Ingredient annotations',
    Camera: 'Camera',
    UseDailyProductsOnly: 'Use daily products only',
    AllProducts: 'All products',
    Reset: 'Reset',
    All: 'All',
    Yes: 'Yes',
    No: 'No',
    ValidatedOnly: 'Validated only',
    NeedsValidation: 'Needs validation',
    EnrolledOnly: 'Enrolled only',
    NotEnrolled: 'Not enrolled',
    HasTicketOnly: 'With tickets',
    WithoutTicket: 'Without tickets',
    HasAnnotationsOnly: 'With bounding boxes',
    WithoutAnnotations: 'Without bounding boxes',
    HasIngredientsOnly: 'With ingredient annotations',
    WithoutIngredients: 'Without ingredient annotations',
    ImageValidated: 'Image validated',
    Enrolled: 'Enrolled',
    Ticket: 'Ticket',
    TraysCount: '{{count}} trays',
    TrayNumber: 'Tray {{id}}',
    ValidatedBboxCount: '{{validated}}/{{total}} validated',
    UnknownTime: 'Unknown time',
    UnableToLoadSummaries: 'Unable to load image summaries.',
    NoTraysMatchFilters: 'No trays match the current filters.',
    CopyLink: 'Copy link',
    DownloadImage: 'Download image',
    EditTools: 'Edit',
    SelectBox: 'Select',
    DrawBox: 'Draw bbox',
    ViewOptions: 'View',
    RunAI: 'Run AI',
    SearchExistingProducts: 'Search products',
    ExistingProductProposals: 'Existing product proposals',
    ProductSearchArea: 'Search area',
    ProductSearchAutomatic: 'Whole image (automatic detection)',
    ProductSearchBox: 'Bbox {{id}}',
    ProductSearchSelectedBoxHint: 'Search crops this bbox directly, without detection.',
    ProductSearchAutomaticHint: 'Select a bbox to search only for the product it contains.',
    ProposalImageNumber: 'Image {{number}}',
    NoImageToSearch: 'No image is available to search.',
    SearchingExistingProducts: 'Searching existing products',
    UnableToSearchProducts: 'Unable to search products. Please try again.',
    NoExistingProductsFound: 'No existing products found for this image.',
    ProposalProductNumber: 'Product {{id}}',
    ProposalMatchScore: 'Match: {{score}}%',
    CloseProductSearch: 'Close',
    SearchProductsAgain: 'Search again',
    MoreActions: 'More actions',
    MoreBboxActions: 'More bbox actions',
    AllChangesSaved: 'All changes saved',
    SavingChanges: 'Saving…',
    AddBox: 'Add box',
    ValidateAll: 'Validate all',
    UnvalidateAll: 'Unvalidate all',
    Analyze: 'Analyze',
    Restore: 'Restore',
    UnsavedChanges: 'Unsaved changes',
    EnrolledImage: 'Enrolled image',
    PickTrayHint: 'Pick a tray from the result rail to open the editor.',
    CapturedAt: 'Captured at',
    Revision: 'Revision',
    ActiveCamera: 'Active camera',
    ImageMedia: 'Image media',
    TrayMeal: 'Tray meal',
    SelectProductBoxHint: 'Select a product box in the canvas to inspect and edit its ingredients.',
    IngredientEditorInWorkspace: 'Ingredient editing is open in the main workspace.',
    SelectedProductBox: 'Selected product box',
    Selected: 'Selected',
    KeyboardNavigationHint: '← / → previous and next image',
    Shortcuts: 'Shortcuts',
    KeyboardShortcuts: 'Keyboard shortcuts',
    ProductModeShortcuts: 'Product annotation mode',
    IngredientModeShortcuts: 'Ingredient annotation mode',
    PreviousImage: 'Previous image',
    NextImage: 'Next image',
    SaveAnnotations: 'Save annotations',
    CancelChanges: 'Cancel changes',
    ToggleAddBox: 'Toggle add product box',
    ToggleImageValidation: 'Toggle image validation',
    ValidateAllBoxes: 'Toggle validation for the selected product box (all if none selected)',
    DeleteSelectedBox: 'Delete selected product box',
    OpenIngredientMode: 'Open ingredient mode',
    ToggleIngredientBox: 'Toggle add ingredient box',
    ValidateIngredientBoxes: 'Toggle validation for the selected ingredient box (all if none selected)',
    DeleteSelectedIngredientBox: 'Delete selected ingredient box',
    BackToImage: 'Back to image',
    IngredientCrops: 'Product crops',
    NoProductCrops: 'No product crops on this image',
    CropNavigation: 'Crop navigation',
    CropValidated: 'Crop validated',
    UnsavedIngredientChangesTitle: 'Save ingredient changes?',
    UnsavedIngredientChangesDescription:
      'You changed ingredients in this editor session. Save them, discard only those ingredient changes, or keep editing.',
    SaveAndReturn: 'Save and return',
    DiscardAndReturn: 'Discard and return',
    KeepEditing: 'Keep editing',
    SaveProductBeforeAnalysis: 'Save this product box before analyzing its ingredients.',
    ExitIngredientMode: 'Return to image',
    JumpToImage: 'Jump to an image',
    ImagePosition: '{{current}} / {{total}}',
    ViewingPosition: 'Viewing {{current}} / {{total}}',
    NearbyImages: '{{count}} nearby',
    ProductBoxNumber: 'Product box #{{id}}',
    UnableToLoadTickets: 'Unable to load tickets.',
    ClientResponse: 'AI response',
    TicketItems: 'Ticket items',
    ResponseHistory: 'Response history',
    ProductsReturned: 'Products returned',
    NoProductsReturned: 'No products returned',
    UnknownReturnedProduct: 'Unknown product',
    RawJson: 'Raw JSON',
    NoClientResponses: 'No AI response stored for this tray.',
    UnableToLoadClientResponses: 'Unable to load stored AI responses.',
    NoTicketRows: 'No CSI ticket rows were returned for this tray.',
    UnknownTicketRow: 'Unknown ticket row',
    OpenProduct: 'Open product #{{id}}',
    NotLinkedToProduct: 'Not linked to a product record.',
    HistoryChanges_one: '{{count}} change',
    HistoryChanges_other: '{{count}} changes',
    HistoryTechnicalDetails: 'Technical details',
    HistoryEntities: {
      product_box: 'Product box',
      product_assignment: 'Product assignment',
      ingredient_box: 'Ingredient box',
    },
    HistoryChangeTypes: { created: 'Created', updated: 'Updated', deleted: 'Deleted' },
    UnknownTimestamp: 'Unknown timestamp',
    UserActor: 'User #{{id}}',
    SystemActor: 'System or unknown actor',
    Retry: 'Retry',
    UnableToLoadHistory: 'Unable to load history.',
    NoHistoryRows: 'No history rows for this scope yet. Create events are not stored in the current backend feed.',
    PageOf: 'Page {{page}} of {{pages}}',
    AnalysisStillRunning: '{{label}} is still running. Refresh manually to check the result.',
    AnnotationsSaved: 'Annotations saved',
    SavingImageInBackground: 'Saving image {{id}} ({{camera}}) in the background…',
    BackgroundSaveFailed:
      'Image {{id}} ({{camera}}) could not be saved. Your changes are retained; reopen the image to review and retry.',
    ReopenUnsavedImage: 'Open image {{id}} ({{camera}})',
    StaleRevisionSaveRejected: 'Save rejected because the revision is stale. Refresh and retry.',
    UnableToSaveAnnotations: 'Unable to save annotations.',
    ImageAnalysisRequested: 'Image analysis requested',
    ImageAnalysisLabel: 'Image analysis',
    UnableToStartImageAnalysis: 'Unable to start image analysis.',
    IngredientAnalysisRequested: 'Ingredient analysis requested',
    IngredientAnalysisLabel: 'Ingredient analysis',
    UnableToStartIngredientAnalysis: 'Unable to start ingredient analysis.',
    ConfirmRestore: 'Restore the original image for the active camera?',
    OriginalImageRestored: 'Original image restored',
    UnableToRestoreOriginalImage: 'Unable to restore the original image.',
    StableLinkCopied: 'Stable link copied',
    ClickToCopyId: 'Click to copy ID',
    CopyId: 'Copy ID {{id}}',
    IdCopied: 'ID {{id}} copied',
    UnableToCopyId: 'Unable to copy ID',
    UnableToCopyLink: 'Unable to copy the link.',
    PollingInfo: '{{label}} is running. The detail query is polling for a new revision.',
    ActiveFilters: 'Active filters',
    NoExtraFilters: 'No extra filters applied.',
    MobileTabs: {
      results: 'Results',
      workspace: 'Workspace',
      inspector: 'Inspector',
    },
  },
  BulkProductEdit: {
    Title: 'Update {{count}} selected product(s)',
    Field: 'Field',
    Value: 'Value',
    Apply: 'Apply',
  },
  RestaurantProductList: {
    Restaurant_Product_List_Title: 'Restaurant products',
    Restaurant_Product_List_Heading: 'Restaurant products',
    New_Product: 'Add a product',
    Products_Deleted_Successfully: 'Products deleted successfully!',
    Product_Delete_Error: 'Error deleting product',
    Product_Added_To: 'Products added to the menu of ',
    Product_Name: 'Product Name',
    Cash_Sys_Code: 'Cash System Code',
    Is_Recurrent: 'Recurrent',
    Is_Industrial: 'Industrial',
    Is_Container: 'Container',
    Is_Returned: 'Returned',
    To_Count: 'To Count',
    Object_Class: 'Kind',
    TableToolbar: {
      Search_Product: 'Search product...',
    },
    Choose_Date_Menu: 'Choose a date for the menu',
    Add_To_Menu: 'Add to menu',
    Delete_Products: 'Delete products',
    Dense: 'Dense',
    Rows_Per_Page: 'Products per page',
    There_Is_Only: 'Warning, there is only',
    Excluded_From_Analysis: 'This product is excluded from analysis',
    Image: 'image',
    Must_Provide: 'for this product. You must provide at least 5 image and contact Trayvisor.',
    Set_Is_Recurrent: 'Convert to reccurent/no reccurrent product.',
    Cancel: 'Cancel',
    True: 'True',
    False: 'False',
    Product: 'Product',
    Original_Product: 'Original Product',
    Linked_Ingredients: 'Linked ingredients',
    Linked_Only: 'Linked only',
    Unlinked_Only: 'Unlinked only',
    Is_Recurrent_Change: 'Recurrent products status changed!',
    Bulk_Edit: 'Bulk edit',
    Bulk_Update_Success: 'Selected products updated successfully!',
    Bulk_Update_Error: 'Error updating selected products',
  },
  RestaurantProductCreate: {
    Restaurant_Product_Create_Title: 'Products: Add a new product',
    Restaurant_Product_Create_Heading_Add: 'Add a new product',
    Restaurant_Product_Create_Heading_Edit: 'Edit a product',
    NewEditForm: {
      Restaurant_Products: 'Products',
      New_Product: 'Add Product',
      Filter_By_Object_Class: 'Filter by object kind',
      Product: 'Product',
      Choose_Product: 'Choose a product',
      Image_Example_Product: 'Image example of the product',
      Product_Required: 'Product is required',
      Product_Name_Required: 'Product name required',
      CashSysCode_Required: 'Cash system code is required',
      Product_Added_Success: 'Product added to your restaurant successfully!',
      Product_Update_Success: 'Update success!',
      Set_Up_Product: 'Set up the product',
      Product_Name: 'Product name',
      CashSysCode: 'Cash system code',
      Is_Recurrent: 'Is recurrent',
      Is_Recurrent_Info: 'Recurrent products will be automatically added to the menu every day.',
      Is_Returned: 'Returned',
      Is_Returned_Info: 'Unreturned products will be excluded from analysis results',
      Add_Product: 'Add Product',
      Save_Changes: 'Saves Changes',
      Use_Daily_Products_only: 'Use daily products only',
      Validated_As_Annotation: 'Validated as annotation',
      No_Selection: 'No selection',
      Start_Typing_Products: 'Start typing to display products',
      Type_Minimum_Characters: 'Type at least {{count}} characters',
      No_Products_Found: 'No products found',
      Linked_Ingredients: 'Linked ingredients',
      Ingredient_Mapping_Title: 'Ingredient mapping',
      Ingredient_Mapping_Scope: 'Mapping scope',
      Ingredient_Mapping_Scope_Restaurant: 'Restaurant override',
      Ingredient_Mapping_Scope_Global: 'Global',
      Ingredient_Mapping_Helper_Text: 'Select the ingredients to attach to this scope.',
      Ingredient_Mapping_Read_Only: 'You can view ingredient mappings, but you do not have permission to change them.',
      Inherited_Global_Ingredients: 'Inherited global ingredients',
      Retry_Ingredient_Mapping: 'Retry sync',
      Ingredient_Mapping_Save_Success: 'Ingredient mappings saved successfully.',
      Ingredient_Mapping_Save_Error: 'Error while saving ingredient mappings.',
      Ingredient_Mapping_Save_Error_With_Conflicts: 'Some ingredients are already mapped in this scope: {{conflicts}}.',
      Ingredient_Mapping_Partial_Error:
        'The restaurant product was saved, but the ingredient mappings could not be updated.',
      Ingredient_Mapping_Partial_Error_With_Conflicts:
        'The restaurant product was saved, but these ingredient mappings conflict: {{conflicts}}.',
      No_Ingredients_Found: 'No ingredients found',
      Select_Product_First: 'Select a product first',
    },
  },
  IngredientAnnotation: {
    Ingredients: 'Ingredients',
    No_Selection: 'No selection',
    All: 'All',
    Validate_All_Ingredient_Boxes: 'Validate all ingredient boxes',
    Unvalidate_All_Ingredient_Boxes: 'Unvalidate all ingredient boxes',
    Add_Ingredient_Box: 'Add ingredient box',
    Save_Ingredient_Changes: 'Save ingredient changes',
    Analyze_Ingredients: 'Analyze ingredients',
    Validated_As_Ingredient_Annotation: 'Validated as ingredient annotation',
    Not_Validated_As_Ingredient_Annotation: 'Not validated as ingredient annotation',
    Ingredient_Box_ID: 'Ingredient Box ID',
    Choose_Ingredient: 'Choose ingredient',
    Ingredient: 'Ingredient',
    Create_Ingredient: 'Create ingredient',
    Picker_Search: 'Search ingredients',
    Picker_Search_Placeholder: 'Name or code…',
    Picker_Results: 'Results',
    Picker_Recent: 'Recent',
    Picker_Categories: 'Categories',
    Picker_All_Categories: 'All categories',
    Picker_Browse: 'Browse categories',
    Picker_Quick_Search: 'Quick search',
    Picker_Back: 'Previous category',
    Picker_Open_Category: 'Browse {{name}}',
    Picker_Select_Category: 'Choose “{{name}}”',
    Picker_No_Results: 'No ingredients found',
    Picker_Clear: 'Remove ingredient',
    Close: 'Close',
    Ingredient_Name: 'Ingredient name',
    Ingredient_Name_Required: 'Ingredient name is required',
    Ingredient_Description: 'Description',
    Validated_As_Annotation: 'Validated as annotation',
    Ingredient_Annotations_Crop_Title: 'Ingredient Annotations: Crop',
    Ingredient_Annotations_Check_Title: 'Ingredient Annotations: Check',
    Ingredient_Annotations_Crop: 'Crop',
    Ingredient_Annotations_Check: 'Check',
    Filters: 'Filters',
    Paging: 'Paging',
    Restaurant: 'Restaurant',
    Dates: 'Dates',
    From_Date: 'From date',
    To_Date: 'To date',
    Enrolled: 'Enrolled',
    Offset: 'Offset',
    Limit: 'Limit',
    Apply_Filter: 'Apply filter',
    Clear_Filter: 'Clear',
    Sort_By: 'Sort By',
    Sort_Newest: 'Newest',
    Sort_Oldest: 'Oldest',
    Sort_Ingredient: 'Ingredient',
    End_Of_List: 'You have seen it all.',
    Scroll_To_Top: 'Scroll to top',
    Save_Product_Box_Error: 'Error while saving product box changes',
    Ingredient_Save_Box_Error: 'Error while saving ingredient box, contact admin!',
    Ingredient_Update_Box_Error: 'Error while updating ingredient box, contact admin!',
    Ingredient_Delete_Box_Error: 'Error while deleting ingredient box, contact admin!',
    Ingredient_Save_Success: 'Ingredient changes saved successfully',
    Ingredient_Save_Error: 'Error saving ingredient changes',
    Ingredient_Create_Success: 'Ingredient created successfully',
    Ingredient_Create_Error: 'Error creating ingredient',
    Ingredients_Analysis_Done: 'Ingredients analysis done',
    Ingredients_Analysis_Started: 'Ingredients analysis started, come back later',
  },
  ProductGeneral: {
    Is_Active: 'Active',
    Product_Title: 'Products',
    Name: 'Product Name',
    Label: 'Product Label',
    Description: 'Product Description',
    Object_Class: 'Object Class (detection)',
    Kind: 'Kind',
    Family: 'Family',
    Brand: 'Brand',
    Food_class: 'Food class',
    Is_Industrial: 'Industrial',
    Is_Content: 'Container',
    To_Count: 'To Count',
    Linked_Ingredients: 'Linked ingredients',
    Search_Query_Too_Long: 'Search must be {{max}} characters or fewer.',
  },
  ProductList: {
    Product_List_Heading: 'Products',
    Product: 'Product',
    List: 'List',
    Add_Product: 'Add a product',
    Merge_Products: 'Merge products',
    Bulk_Edit: 'Bulk edit',
    Bulk_Update_Success: 'Selected products updated successfully!',
    Bulk_Update_Error: 'Error updating selected products',
    TableRow: {
      Inactive: 'Inactive',
    },
    TableHead: {
      Id: 'ID',
    },
    TableToolbar: {
      Status: 'Status',
      Status_active: 'Active',
      Status_inactive: 'Inactive',
      Status_all: 'All',
      Search_Product: 'Search product...',
    },
    Dense: 'Dense',
    Rows_Per_Page: 'Products per page',
  },
  ProductCreate: {
    Is_Active_Info: 'Controls whether this product appears by default in the product list.',
    Product_Heading_Add: 'Add a new product',
    Product_Heading_Edit: 'Edit a product',
    New_Product: 'New product',
    Set_Up_Product: 'Set up the new product',
    Product_Name_Required: 'Product name required',
    Description_Required: 'Description required',
    Label_Required: 'Label required',
    Is_Indus_Required: 'Industrial required',
    Is_Content_Required: 'Content required',
    To_Count_Required: 'To count required',
    Kind_Required: 'Kind required',
    Family_Required: 'Family required',
    Brand_Required: 'Brand required',
    Object_Class_Required: 'Object class required',
    Images_Required: '1 image at least is required',
    Product_Added_Success: 'Product added successfully!',
    Branch_Added_Success: 'Brand added successfully!',
    Food_Class_Added_Success: 'Food class added successfully!',
    Product_Update_Success: 'Update success!',
    Add_Product: 'Add Product',
    Save_Changes: 'Saves Changes',
    Add_Brand: 'Add Brand',
    Add_New_Brand: 'Add New Brand',
    Brand_Name: 'Brand Name',
    Add_Food_Class: 'Add Food Class',
    Add_New_Food_Class: 'Add New Food Class',
    Enrolled_By: 'Enrolled by',
    Is_Industrial_Info: 'Industrials products are the packaged one.',
    Is_Content_Info: 'For the recognition by container (plate).',
    To_Count_Info: 'Count ingredients in this product',
    Image_Example_Product: 'Image example',
    NutritionCard: {
      Set_Up_Nutrition_Card: 'Set up the nutrition informations',
      Calcium: 'Calcium',
      Cho: 'CHO (Carbohydrates)',
      Diet_fibre: 'Dietary Fiber',
      Diet_Iron: 'Iron',
      Gross_Weight: 'Gross Weight',
      Kcal: 'Kcal',
      Net_Weight: 'Net Weight',
      Protein: 'Protein',
      Sat_Fat: 'Saturated Fat',
      Sodium: 'Sodium',
      Sugars: 'Sugars',
      Total_Fat: 'Total Fat',
    },
  },
  Products: {
    ClassOptions: {
      Class_All: 'All',
      Class_Indus_Food: 'Industrial',
      Class_Fruit: 'Fruit',
      Class_Drink: 'Drink',
      Class_Dessert_Starter: 'Starter/Dessert',
      Class_Dish: 'Dish',
      Class_Bread: 'Bread',
      Class_Unknown: 'Unknown',
      Class_Others: 'Other',
    },
  },
  Menus: {
    Menus_Title: 'Menus',
    Menus_Header: 'Menus',
    Menu_Date: 'Menu date',
    Menus_Card_Heading: 'Cards',
    Add_Products: 'Add products to menu',
    Delete_From_Menu: 'Delete from menu',
    Product_Removed_From_Menu_Success: 'Product removed from menu',
    Product_Remove_From_Menu_Error: 'Error removing product from menu',
    Display_Menu_History: 'Show menu history',
    Last_Menu_Received_at: 'Last menu received at',
    No_Menu_Received_Today: 'No menu received today',
    Menu_History: 'Menu history',
    Menu_History_Close: 'Close menu history',
    Menu_History_Received: 'Received menus',
    Menu_History_Products_View: 'Products',
    Menu_History_Search: 'Search by product name or code',
    Menu_History_Product_Count_one: '{{count}} product',
    Menu_History_Product_Count_other: '{{count}} products',
    Menu_History_No_Matches: 'No products match your search',
    Menu_History_No_Products: 'This archive contains no products',
    Menu_History_Unnamed_Product: 'Unnamed product',
    Menu_History_Code: 'Code',
    Menu_History_Catering_Code: 'Catering code',
    Menu_History_Visual_Id: 'Visual ID',
    Menu_History_Labels_one: '{{count}} label',
    Menu_History_Labels_other: '{{count}} labels',
    Menu_History_Download: 'Download JSON',
    Menu_History_Local_Time: 'Time displayed in local timezone (24h)',
    Menu_History_Load_Error: 'Unable to load the archived menu',
    Menu_History_Refresh_Error: 'Menu resent, but the display could not be refreshed',
    Menu_Manual_Resend: 'Manually resent menu',
    Menu_Resend_Provenance: 'Manually resent by {{user}} from the menu received on {{date}} at {{time}}',
    Menu_Archive_Pending: 'The new menu is not yet visible in the history',
    Menu_Resend: 'Resend this menu',
    Menu_Resending: 'Resending…',
    Menu_Resend_Success: 'Menu resent to the API',
    Menu_Resend_Error: 'Unable to resend the menu',
  },
  Visualization: {
    Dashboard: 'Dashboard',
    Visualization: 'Visualize',
    Enrollment: 'Enrollment',
    Analysis: 'Analysis',
    No_Enrollment_Found: 'No Enrollment found for the selected date',
  },
  DeviceCreate: {
    Serial_Number: 'Serial Number',
    Name: 'Name',
    Pitunnel_Device_Id: 'PiTunnel Device ID',
    Min_Value_Required: 'Minimum value required',
    Max_Value_Required: 'Maximum value exceeded',
    Number_Required: 'Must be a number',
    Integer_Required: 'Must be an integer',
    Field_Required: '{{field}} is required',
    Device_Profile_Required: 'Device Profile is required',
    Brightness_Target_Required: 'Brightness Target is required',
    Focus_Required: 'Focus is required',
    LED_PWMIntensity_Required: 'LED Intensity is required',
    LED_PWMChip_Required: 'LED PWM Chip is required',
    LED_PWMChip_Invalid: 'Only values from 0 to 3 are allowed',
    LED_PWMChannel_Required: 'LED PWM Channel is required',
    LED_Red_Required: 'LED Red Pin is required',
    LED_Green_Required: 'LED Green Pin is required',
    LED_Yellow_Required: 'LED Yellow Pin is required',
    Create_Success: 'Device created successfully',
    Error_Occurred: 'An error occurred',
    Update_Success: 'Device updated successfully',
    Device_Information: 'Device Information',
    Device_Profile: 'Device Profile',
    Loading: 'Loading...',
    Camera_Parameters: 'Camera Parameters',
    Camera_Controls: 'Camera Controls',
    RGB_Camera_Controls: 'RGB Camera Controls',
    RGB_Auto_Tuning: 'RGB Auto-Tuning',
    RGB_Capture_Output: 'RGB Capture Output',
    RealSense_Capture_Output: 'RealSense Capture Output',
    Thermal_Capture_Output: 'Thermal Capture Output',
    LED_Configuration: 'LED Configuration',
    RGB_Camera_FPS_Limit: 'RGB Camera FPS Limit',
    Brightness_Backend: 'Brightness Backend',
    Brightness_Target: 'Brightness Target',
    Brightness_Target_Tolerance: 'Brightness Target Tolerance',
    Brightness_Percentile: 'Brightness Percentile',
    Exposure_Time_Min_Us: 'Minimum Exposure Time (us)',
    Exposure_Time_Max_Us: 'Maximum Exposure Time (us)',
    Gain_Limit_Min: 'Minimum Gain Limit',
    Gain_Limit_Max: 'Maximum Gain Limit',
    Host_Auto_Skip_Frames: 'Host Auto Skip Frames',
    Focus_Auto_Mode: 'Auto Focus Mode',
    Frame_Freshness_Timeout: 'Frame Freshness Timeout (ms)',
    Brightness_Region_Ratio: 'Brightness Region Ratio',
    Focus_Region_Ratio: 'Focus Region Ratio',
    Focus: 'Focus',
    RGB_Capture_Extension: 'RGB Capture Extension',
    RGB_Capture_Quality: 'RGB Capture Quality',
    RGB_Continuous_Encoding: 'RGB Continuous Encoding',
    RS_RGB_Capture_Quality: 'RealSense RGB Capture Quality',
    RS_RGB_Continuous_Encoding: 'RealSense RGB Continuous Encoding',
    RS_Depth_Capture_Quality: 'RealSense Depth Capture Quality',
    RS_Depth_Continuous_Encoding: 'RealSense Depth Continuous Encoding',
    Thermal_Capture_Quality: 'Thermal Capture Quality',
    Thermal_Continuous_Encoding: 'Thermal Continuous Encoding',
    LED_PWMIntensity: 'LED Intensity',
    LED_PWMChip: 'LED PWM Chip',
    LED_PWMChannel: 'LED PWM Channel',
    LED_PWMFrequency: 'LED PWM Frequency',
    LED_Red: 'LED Red Pin',
    LED_Green: 'LED Green Pin',
    LED_Yellow: 'LED Yellow Pin',
    RS_Camera_Enabled: 'RS Camera Enabled',
    Thermal_Camera_Enabled: 'Thermal Camera Enabled',
    LED_Enabled: 'LED Enabled',
    Add_Device: 'Add Device',
    Save_Changes: 'Save Changes',
    Edit_Device: 'Edit Device',
    API_HOST_URL: 'API Host URL',
    API_HOST_URL_Copied: 'API Host URL copied to clipboard',
    Copy_Host_URL: 'Copy Host URL',
    Serial_Number_Tooltip: 'Unique identifier for the device.',
    Name_Tooltip: 'Name of the device.',
    Pitunnel_Device_Id_Tooltip: 'Device ID for the device in PiTunnel.',
    Device_Profile_Tooltip: 'ID of the device profile associated with the device.',
    API_HOST_URL_Tooltip: 'API host URL for the device.',
    RGB_Camera_FPS_Limit_Tooltip: 'Maximum capture FPS for the RGB camera.',
    Brightness_Backend_Tooltip: 'Brightness control backend for the RGB camera.',
    Brightness_Target_Tooltip: 'Target brightness for the RGB camera.',
    Brightness_Target_Tolerance_Tooltip: 'Allowed deviation around the brightness target.',
    Brightness_Percentile_Tooltip: 'Percentile used when computing RGB image brightness.',
    Exposure_Time_Min_Us_Tooltip: 'Minimum RGB camera exposure time in microseconds.',
    Exposure_Time_Max_Us_Tooltip: 'Maximum RGB camera exposure time in microseconds.',
    Gain_Limit_Min_Tooltip: 'Minimum RGB camera gain.',
    Gain_Limit_Max_Tooltip: 'Maximum RGB camera gain.',
    Host_Auto_Skip_Frames_Tooltip: 'Number of host-side frames to skip during auto adjustments.',
    Focus_Auto_Mode_Tooltip: 'Autofocus mode used by the RGB camera.',
    Frame_Freshness_Timeout_Tooltip: 'Maximum age in milliseconds before an RGB frame is considered stale.',
    Brightness_Region_Ratio_Tooltip: 'Image area ratio used for brightness calculations.',
    Focus_Region_Ratio_Tooltip: 'Image area ratio used for focus calculations.',
    Focus_Tooltip: 'Manual focus setting for the RGB camera.',
    RGB_Capture_Extension_Tooltip: 'Output image extension for RGB captures.',
    RGB_Capture_Quality_Tooltip: 'Output quality or compression level for RGB captures.',
    RGB_Continuous_Encoding_Tooltip: 'Whether RGB frames are encoded continuously.',
    RS_Camera_Enabled_Tooltip: 'Flag to enable or disable the Realsense camera.',
    RS_RGB_Capture_Quality_Tooltip: 'Output quality for RealSense RGB captures.',
    RS_RGB_Continuous_Encoding_Tooltip: 'Whether RealSense RGB frames are encoded continuously.',
    RS_Depth_Capture_Quality_Tooltip: 'PNG compression level for RealSense depth captures.',
    RS_Depth_Continuous_Encoding_Tooltip: 'Whether RealSense depth frames are encoded continuously.',
    Thermal_Camera_Enabled_Tooltip: 'Flag to enable or disable the thermal camera.',
    Thermal_Capture_Quality_Tooltip: 'PNG compression level for thermal captures.',
    Thermal_Continuous_Encoding_Tooltip: 'Whether thermal frames are encoded continuously.',
    LED_PWMIntensity_Tooltip: 'PWM intensity for the LED.',
    LED_PWMChip_Tooltip: 'PWM chip number for the LED.',
    LED_PWMChannel_Tooltip: 'PWM channel number for the LED.',
    LED_PWMFrequency_Tooltip: 'PWM frequency for LED intensity control.',
    LED_Red_Tooltip: 'GPIO pin number for the red LED.',
    LED_Green_Tooltip: 'GPIO pin number for the green LED.',
    LED_Yellow_Tooltip: 'GPIO pin number for the yellow LED.',
    LED_Enabled_Tooltip: 'Flag to enable or disable the LED.',
  },
  DevicesList: {
    Serial_Number: 'Serial Number',
    Device_Name: 'Device Name',
    Profile_Name: 'Profile Name',
    Status_Update: 'Update Status',
    All: 'All',
    Online: 'Online',
    Offline: 'Offline',
    Device_List_Title: 'Device List',
    Device_List_Heading: 'Device List',
    Dashboard: 'Dashboard',
    New_Device: 'New Device',
    Rows_Per_Page: 'Rows per page:',
    Dense: 'Dense',
    Search_Device_Name_Serial_Version: 'Search by device name, serial number, or version',
  },
  DeviceDetails: {
    Select_Device_To_Display_Details: 'Select a device to display details',
    Open_Terminal_In_New_Tab: 'Open Terminal in New Tab',
    Terminal: 'Terminal',
    System_Information: 'System Information',
    CPU_Usage: 'CPU Usage',
    Memory_Usage: 'Memory Usage',
    Disk_Usage: 'Disk Usage',
    CPU_Temperature: 'CPU Temperature',
    GPU_Temperature: 'GPU Temperature',
    Hostname: 'Hostname',
    MAC_Address: 'MAC Address',
    Tunnels: 'Tunnels',
    Destination: 'Destination',
    No_Tunnels_Available: 'No tunnels available.',
    Device_Offline_Info_Unavailable: 'Device is offline. Additional information is unavailable.',
    Loading: 'Loading...',
    Camera_Not_Available: 'Camera not available',
    Take_RGB_Photo: 'Take RGB photo',
    Take_Depth_Photo: 'Take depth photo',
    Take_Thermal_Photo: 'Take thermal photo',
    Autofocus_Adjustment: 'Autofocus adjustment',
    Autofocus_Adjustment_Info: 'Run autofocus, save the returned focus, and capture a new RGB photo',
    Autofocus_Adjustment_Failed: 'Autofocus adjustment failed',
    Autofocus_Adjustment_Invalid_Focus: 'Autofocus adjustment returned an invalid focus value',
    Autofocus_Adjustment_Save_Failed: 'Failed to save the autofocus value',
    Photo_Capture_Failed: 'Failed to capture photo',
    RGB: 'RGB',
    Depth: 'Depth',
    Thermal: 'Thermal',
    Restart_Device_Info: 'Restart device or service',
    Restart: 'Restart',
    Restart_Success: 'Restart successful',
    Restart_Failed: 'Restart failed',
    Select_Restart_Option: 'Select a restart option',
    Backend: 'Backend',
    Controller: 'Controller',
    Devices: 'Devices',
    Copy_URL: 'Copy URL',
  },
  DevicesTableRow: {
    Edit: 'Edit',
    Delete: 'Delete',
  },
  DeviceProfilesList: {
    ID: 'ID',
    Name: 'Name',
    Description: 'Description',
    Version: 'Version',
    Heading: 'Device Profiles',
    New_Profile_Button: 'New Profile',
    Edit: 'Edit',
    Device_Profiles: 'Device Profiles',
    Search_Profile_Placeholder: 'Search profile by name, description or version...',
    Rows_Per_Page: 'Rows per page',
    Dense: 'Dense',
  },
  DeviceProfilesCreate: {
    Create_Page_Title: 'Device Profile: Create',
    Edit_Page_Title: 'Device Profile: Edit',
    Create_Heading: 'Create Device Profile',
    Edit_Heading: 'Edit Device Profile',
    Name_Label: 'Name',
    Description_Label: 'Description',
    Version_Label: 'App Version',
    Version_Placeholder: 'e.g., 1.0.0 or v1.0.0',
    Name_Required: 'Name is required',
    Description_Required: 'Description is required',
    Version_Required: 'Version is required',
    Version_Format_Invalid: 'Version format is invalid (should be like 1.0.0 or v1.0.0)',
    Profile_Details: 'Profile Details',
    Add_Profile_Button: 'Add Profile',
    Save_Changes_Button: 'Save Changes',
    Create_Success: 'Device profile created successfully',
    Update_Success: 'Device profile updated successfully',
  },
  CiqualItems: {
    Ciqual: 'Ciqual',
    Management_Title: 'Menus Management',
    List_Page_Title: 'Ciqual items',
    List_Heading: 'Ciqual items',
    Create_Page_Title: 'Ciqual item: Create',
    Edit_Page_Title: 'Ciqual item: Edit',
    Details_Page_Title: 'Ciqual item details',
    Create_Heading: 'Create Ciqual item',
    Edit_Heading: 'Edit Ciqual item',
    Details_Heading: 'Ciqual item details',
    Search_Placeholder: 'Search by ID, code, official name or custom name...',
    Actions: {
      Add_Item: 'Add item',
      View: 'View',
      Edit: 'Edit',
      Duplicate: 'Duplicate',
      Delete: 'Delete',
      Cancel: 'Cancel',
      Save_Changes: 'Save Changes',
    },
    DeleteDialog: {
      Title: 'Delete Ciqual item',
      Description: 'Are you sure you want to delete {{name}}? This action cannot be undone.',
    },
    Filters: {
      Is_Enabled: 'Is Enabled',
      All: 'All',
      True: 'True',
      False: 'False',
    },
    Form: {
      General_Section: 'General information',
      Classification_Section: 'Classification',
      Nutrition_Section: 'Nutrition per 100g',
    },
    Fields: {
      Id: 'ID',
      Alim_Code: 'CIQUAL code',
      Alim_Nom_Fr: 'Official French name',
      Alim_Nom_Fr_Custom: 'Custom French name',
      Used_In_Pipeline: 'Enabled',
      Alim_Grp_Code: 'Group code',
      Alim_Ssgrp_Code: 'Subgroup code',
      Alim_Ssssgrp_Code: 'Sub-subgroup code',
      Alim_Grp_Nom_Fr: 'Group name',
      Alim_Ssgrp_Nom_Fr: 'Subgroup name',
      Alim_Ssssgrp_Nom_Fr: 'Sub-subgroup name',
      energy_kj: 'Energy (kJ)',
      energy_kcal: 'Energy (kcal)',
      protein_g: 'Protein (g)',
      carbs_g: 'Carbohydrates (g)',
      sugars_g: 'Sugars (g)',
      fat_g: 'Fat (g)',
      sat_fat_g: 'Saturated fat (g)',
      fibre_g: 'Dietary fibre (g)',
      salt_g: 'Salt (g)',
    },
    Validation: {
      Alim_Code_Required: 'CIQUAL code is required',
      Alim_Nom_Fr_Required: 'Official French name is required',
      Number: 'Must be a number',
      Integer: 'Must be an integer',
    },
    Messages: {
      Create_Success: 'Ciqual item created successfully',
      Update_Success: 'Ciqual item updated successfully',
      Create_Error: 'Error creating Ciqual item',
      Update_Error: 'Error updating Ciqual item',
      Load_Error: 'Error loading Ciqual item',
      Delete_Success: 'Ciqual item deleted successfully',
      Delete_Error: 'Error deleting Ciqual item',
      Delete_Conflict: 'This Ciqual item is referenced by other records and cannot be deleted.',
    },
  },
  DishNutritionProfiles: {
    List_Page_Title: 'Dish nutrition profiles',
    List_Heading: 'Dish nutrition profiles',
    Details_Page_Title: 'Dish nutrition profile details',
    Details_Heading: 'Dish nutrition profile',
    Search_Placeholder: 'Search by ID, name, normalized name or meal kind...',
    Sections: {
      Profile: 'Profile',
      Nutrition: 'Nutrition per 100g',
      Components: 'CIQUAL components',
    },
    Fields: {
      Id: 'ID',
      Display_Name: 'Display name',
      Normalized_Name: 'Normalized name',
      Meal_Kind: 'Meal kind',
      Components: 'Components',
      Energy_Kcal: 'Energy (kcal/100g)',
      Created_At: 'Created at',
      Updated_At: 'Updated at',
      Ciqual_Code: 'CIQUAL code',
      Ciqual_Item: 'CIQUAL item',
      Proportion: 'Proportion',
      energy_kj_per_100g: 'Energy (kJ/100g)',
      energy_kcal_per_100g: 'Energy (kcal/100g)',
      protein_g_per_100g: 'Protein (g/100g)',
      carbs_g_per_100g: 'Carbohydrates (g/100g)',
      sugars_g_per_100g: 'Sugars (g/100g)',
      fat_g_per_100g: 'Fat (g/100g)',
      sat_fat_g_per_100g: 'Saturated fat (g/100g)',
      fibre_g_per_100g: 'Dietary fibre (g/100g)',
      salt_g_per_100g: 'Salt (g/100g)',
    },
    Messages: {
      Load_Error: 'Error loading dish nutrition profile',
      No_Components: 'No CIQUAL components',
    },
  },
  Others: {
    Pending: 'Pending',
    In_Progress: 'In Progress',
    Completed: 'Completed',
    Dashboard: 'Dashboard',
    Loading: 'Loading...',
    Error_Occurred: 'An error occurred. Please try again.',
    Rows_Per_Page: 'Rows per page:',
    Dense: 'Dense',
    View_Annotations: 'View annotations',
    Hide_Not_Returned_BBoxes: 'Hide bboxes not returned to client',
    Returned_To_Client: 'Returned to client',
    Not_Returned_To_Client: 'Not returned to client',
    Copy_BBox_ID: 'Copy BBox ID',
    Validate_BBox: 'Validate bounding box',
    Unvalidate_BBox: 'Unvalidate bounding box',
    BBox_ID_Copied: 'BBox ID copied',
    Detection_Score: 'Detection score',
  },
  IdentificationToken: {
    Generate_Token_First: 'Please generate token first',
    Token_Copied: 'Token copied to clipboard',
    Identification_Title: 'Identification (Token)',
    Identification_Heading: 'Generate Identification Token',
    Admin: 'Admin',
    Expiration_Time: 'Expiration time (days)',
    Generate_Token: 'Generate Identification Token',
    Click_To_Copy: 'Click to copy',
    Click_To_Download: 'Click to download',
  },
  Selectors: {
    UsersSelector: 'Select user',
  },
  LanguageSelector: {
    Languages: 'Languages',
    en: 'English',
    fr: 'French',
    de: 'German',
  },
  ResetPassword: {
    Password_No_Match: "Password didn't match",
    Password_Too_Short: 'Must be at least 8 characters long',
    Success: 'Success',
    Invalid_Token: 'Invalid token',
    Reset_Password: 'Reset password',
    Password: 'Password',
    Confirm_Password: 'Confirm password',
    Confirm: 'Confirm',
  },
  Login: {
    Invalid_Login: 'Invalid username or password.',
    Successful_Login: 'Successful login',
    Login_Instructions: 'Enter a valid username and password.',
    Username: 'Email',
    Enter_Username: 'Enter username',
    Password: 'Password',
    Enter_Password: 'Enter password',
    Connect: 'Sign In',
    Email_Must_Valid: 'Email must be a valid email address',
    Email_Required: 'Email is required',
    Password_Required: 'Password is required',
    Remember_Me: 'Remember me',
  },
  Reporting: {
    Reporting_Title: 'Reports: Daily',
    Reporting_Heading: 'Daily Reports',
    Reporting: 'Reporting',
    Daily: 'Daily',
    Total_Trays: 'Total trays',
    Total_Tickets: 'Total tickets',
    Wrong_Trays: 'Wrong trays',
    Perc_Of_Good_Trays: '% of good trays (net)',
    Perc_Of_Good_Trays_Live: '% of good trays (gross)',
    Product_Name: 'Product name',
    Object_Class: 'Object Class (detection)',
    Precision: 'Precision',
    Recall: 'Recall',
    F1_Score: 'F1 Score',
    TP_Description: 'True Positive:\nNumber of items correctly identified.',
    FP_Description:
      'False Positive:\nNumber of items incorrectly identified. We predicted that the item was present, but it was not.',
    FN_Description:
      'False Negative:\nNumber of items not identified. We predicted that the item was not present, but it was.',
    Precision_Description: 'Precision: How much of the predicted items are actually present.',
    Recall_Description: 'Recall: How much of the actual items are predicted.',
    F1_Score_Description: 'F1 Score: The harmonic mean of precision and recall.',
    Statistics_Per_Product: 'Statistics per product',
    ObjectClasses_To_Remove: 'Object classes to remove',
  },
  ReportingSummaryCSI: {
    Dashboard: 'Dashboard',
    Reporting: 'Reporting',
    Breadcrumb: 'Summary CSI',
    Page_Title: 'Reports: Summary CSI',
    Page_Heading: 'Summary Reports: CSI',
    From_Date: 'From date',
    To_Date: 'To date',
    Restaurants_Label: 'CSI restaurants',
    Select_All_Restaurants: 'Select all restaurants',
    Restaurants_Placeholder: 'Select restaurants',
    Submit: 'Submit',
    Table_Restaurant: 'Name',
    Table_Restaurant_Id: 'ID',
    No_CSI_Restaurants: 'No CSI restaurants are available for your account.',
    Invalid_Date_Range: 'The from date must be earlier than or equal to the to date.',
    Weekends_Excluded_Note: 'Weekends are excluded from CSI reporting dates.',
    Select_At_Least_One_Restaurant: 'Select at least one CSI restaurant.',
    Error_Loading_Data: 'Error loading summary reporting data.',
    No_Results: 'No results found for the selected filters.',
    No_Results_Click_Submit: 'No results yet. Click Submit to fetch data.',
  },
  RestaurantList: {
    Restaurant_Title: 'Restaurants',
    Restaurant_Heading_List: 'Restaurants',
    New_Restaurant: 'New restaurant',
    TableHead: {
      Search_Restaurant: 'Search restaurant...',
      Choose_Country: 'Choose country',
      Is_Active: 'Is active',
      Project: 'Project',
    },
    TableRow: {
      Id: 'ID',
      Name: 'Name',
      Alias_Name: 'Alias name',
      Project: 'Project',
      City: 'City',
      Group_Name: 'Group name',
      Cash_Sys_Name: 'Cash system name',
      Country: 'Country',
      Active: 'Active',
      Inactive: 'Inactive',
      Health: 'Health',
      Checkout: 'Checkout',
    },
  },
  RestaurantCreate: {
    Restaurant_Title: 'Restaurants',
    Restaurant_Heading_Add: 'Add a new restaurant',
    Restaurant_Heading_Edit: 'Edit a restaurant',
    Restaurant: 'Restaurant',
    Restaurant_Added_Success: 'Restaurant added successfully!',
    Restaurant_Updated_Success: 'Restaurant updated successfully!',
    Restaurant_Save_Error: 'Error while saving restaurant',
    FormFields: {
      Name: 'Name',
      Alias_Name: 'Alias name',
      Project: 'Project',
      City: 'City',
      Restaurant_Group: 'Group',
      Cash_System: 'Cash system',
      Address: 'Address',
      Zip_Code: 'Zip/Code',
      Country: 'Country',
      Is_Active: 'Active',
      Hide_Mode: 'Hide mode',
      Use_Qrcode_Reader: 'Use QR code reader',
      Kiosk_Type: 'Kiosk type',
      No_Kiosk_Type: 'No kiosk type',
      Health: 'Health',
      Checkout: 'Checkout',
      TrayHealth_Settings: 'TrayHealth settings',
      TrayScan_Settings: 'TrayScan settings',
      Use_Llm_Analysis: 'Use LLM analysis',
      Use_Counting_Analysis: 'Use counting analysis',
      Authorized_Users: 'Authorized users',
      Create_Restaurant: 'Create restaurant',
      Save_Changes: 'Save changes',
    },
  },
  ApiDocumentation: {
    Copy_Doc: 'Copy OpenAPI doc (JSON)',
    Cash_System_Selector: 'Select a cash system',
    Doc_Copied: 'Documentation copied to clipboard',
  },
  Components: {
    BlockContent: {
      Drop_Or_Select_File: 'Drop or Select file',
      Drop_File_Or_Click: 'Drop files here or click',
      Browse: 'browse',
      Thorough_Your_Machine: 'thorough your machine',
    },
    DeleteDialog: {
      Are_You_Sure: 'Are you sure you want to delete ',
      Product: 'product',
      Action_Cannot_Undone: 'This action cannot be undone.',
    },
    MergeDialog: {
      Are_You_Sure: 'Are you sure you want to merge ',
      Product: 'product',
      Action_Cannot_Undone: 'This action can not be undone !',
      Merge: 'Merge',
    },
  },
  Clients: {
    Clients_Title: 'Clients',
    Clients_Heading_List: 'Clients List',
    New_Client: 'New Client',
    TableToolbar: {
      Search_Client: 'Search client...',
    },
    TableHead: {
      Id: 'ID',
      Client_Hash: 'Client Hash',
      Restaurant: 'Restaurant',
      Status: 'Status',
    },
    Form: {
      ClientHash: 'Client Hash',
      ClientHash_Required: 'Client hash is required',
      ActiveStatus: 'Active Status',
      Status_Required: 'Status is required',
      Create_Client: 'Create Client',
      Save_Changes: 'Save Changes',
      Client_Created_Success: 'Client created successfully!',
      Client_Updated_Success: 'Client updated successfully!',
    },
  },
  HealthMenu: {
    // Main sections
    Management_Title: 'Menus Management',
    Menu_Title: 'Menus',
    Menu_List_Heading: 'List',

    // Common actions (reused across health menu components)
    Actions: {
      Add: 'Add',
      Edit: 'Edit',
      Delete: 'Delete',
      Cancel: 'Cancel',
      Save_Changes: 'Save Changes',
      Add_Product: 'Add A Product',
      Edit_Product: 'Edit Product',
    },

    // Common form fields
    Fields: {
      Name: 'Name',
      Description: 'Description',
      Type: 'Type',
      Menu_Type: 'Menu Type',
      Date: 'Date',
      Meal_Time: 'Meal Time',
      Menu_Document: 'Menu document',
      Dish_Profile: 'Dish profile',
      Substitution: 'Substitution',
    },

    // Validation messages
    Validation: {
      Name_Required: 'Name is required',
      Type_Required: 'Type is required',
      Menu_Type_Required: 'Menu type is required',
      Meal_Time_Required: 'Meal time is required',
      Must_Be_Greater_Than_Zero: 'Must be greater than or equal to 0',
    },

    // Table interface
    Table: {
      Search_Product: 'Search product...',
      Search_Category: 'Search category...',
      Dense: 'Dense',
      Rows_Per_Page: 'Rows per page',
      Loading_Menu_Items: 'Loading menu items...',
    },

    // Status messages
    Messages: {
      Success_Adding: 'Product added successfully',
      Success_Creating: 'Product created successfully',
      Success_Updating: 'Product updated successfully',
      Success_Deleting: 'Product deleted successfully',
      Error_Adding: 'Error adding product',
      Error_Creating: 'Error creating product',
      Error_Updating: 'Error updating product',
      Error_Deleting: 'Error deleting product',
      No_Data_Found: 'No data found for',
      No_Type: 'No type',
      No_Description: 'No description',
      No_Menus_Found: 'No menus found',
      No_Menus_For_Restaurant: 'No menus for this restaurant',
      Select_Restaurant_To_View_Menus: 'Select a restaurant to view menus',
    },

    // Common values
    Common: {
      Yes: 'Yes',
      No: 'No',
    },

    // Nutritional information
    Nutrition: {
      Nutritional_Values: 'Nutritional Values',
      Has_Nutritional_Values: 'Has Nutritional Values',
      Total_Fat: 'Total Fat',
      Sat_Fat: 'Saturated Fat',
      Protein: 'Protein',
      Sodium: 'Sodium',
      Calcium: 'Calcium',
      Cho: 'Carbohydrate',
      Sugars: 'Sugars',
      Diet_Iron: 'Iron',
      Diet_Fibre: 'Dietary Fiber',
      Kcal: 'Energy',
      Net_Weight: 'Net Weight',
      Gross_Weight: 'Gross Weight',
    },

    // Category-specific
    Category: {
      Categories_Title: 'Menus Categories',
      Categories_Heading: 'Menu Categories',
      Add_Menu_Category: 'Add Menu Category',
      Edit_Menu_Category: 'Edit Menu',
      Is_Substitution: 'Substitution Menu',
      Success_Adding: 'Successfully added',
      Success_Updating: 'Successfully updated',
      Error_Adding: 'Error adding',
      Error_Updating: 'Error updating',
    },

    // File import
    Import: {
      Page_Title: 'Import Menu Files',
      Page_Heading: 'Import Menu Files',
      Upload_Section_Title: 'Upload a menu',
      Upload_Helper_Text: 'Drop files here or click browse through your machine',
      Select_Categories_Title: 'Select present menu categories:',
      Select_Dates_Title: 'Select menu validity dates:',
      Start_Date_Label: 'Start date',
      End_Date_Label: 'End date',
      Submit_Button: 'Pre-fill the menu',
      Success_Message: 'File uploaded successfully',
      Error_No_Categories: 'Please select at least one menu category',
      Error_No_Restaurant: 'Please select a restaurant to import menu files.',
      Error_No_Categories_Available:
        'No menu categories found. Please create some menu categories first before importing files.',
      Loading_Categories: 'Loading menu categories...',
      Error_Loading_Categories: 'Error loading menu categories:',
      Validation: {
        Start_Date_Required: 'Start date is required',
        End_Date_Required: 'End date is required',
        File_Required: 'File is required',
        Only_PDF_Files_Allowed: 'Only PDF files are allowed',
      },
    },

    // Documents Status
    Documents: {
      // Page information
      Page_Title: 'Files Status',
      Page_Heading: 'Files Status',

      // Table fields
      Fields: {
        ID: 'ID',
        Upload_Datetime: 'Upload Datetime',
        Status: 'Status',
        UUID: 'UUID',
        Processed_Datetime: 'Processed Datetime',
        Date_Range: 'Date Range',
      },

      // Status labels
      Status: {
        All: 'All',
        Queued: 'Queued',
        Processing: 'Processing',
        Processed: 'Processed',
        Error: 'Error',
      },

      // Actions
      Actions: {
        Download: 'Download',
        Download_Selected: 'Download Selected Files',
        Reprocess: 'Reprocess',
        Delete: 'Delete',
      },

      Delete_Confirmation: {
        Title: 'Delete menu document?',
        Description:
          'This will permanently delete {{filename}} and all of its extracted menu items, including any associated analyses. This action cannot be undone.',
      },

      // Table interface
      Table: {
        Search_Document: 'Search document...',
        Dense: 'Dense',
        Rows_Per_Page: 'Rows per page',
      },

      // Messages
      Messages: {
        Loading: 'Loading...',
        Error_Loading: 'Error loading data',
        Download_Success: 'Download successful',
        Download_Error: 'Error downloading file',
        Reprocess_Success: 'Document reprocessing started successfully',
        Reprocess_Error: 'Error reprocessing document',
        Delete_Success: 'Document deleted successfully',
        Delete_Error: 'Error deleting document',
        Bulk_Download_Success: '{{count}} file(s) downloaded successfully',
        Bulk_Download_Partial_Error: '{{errorCount}}/{{totalCount}} files failed to download',
        Bulk_Download_Error: 'Error downloading selected files',
      },
    },

    // Prompt Editor
    PromptEditor: {
      // Page information
      Page_Title: 'Prompt Editor',
      Page_Heading: 'Prompt Editor',

      // Form sections
      Upload_Section_Title: 'Upload a menu',
      Select_Categories_Title: 'Select menu categories',
      Select_Dates_Title: 'Select start and end dates',
      Prompt_Section_Title: 'Model & Prompts configuration',

      // Form labels
      From_Date_Label: 'From date',
      To_Date_Label: 'To date',
      Model_Label: 'Model',
      System_Prompt_Label: 'System Prompt',
      User_Prompt_Label: 'User Prompt',

      // Placeholders
      System_Prompt_Placeholder: 'Enter system prompt...',
      User_Prompt_Placeholder: 'Enter user prompt...',

      // Buttons
      Run_Processing_Button: 'Run Processing',
      Save_Button: 'Save Prompt',
      Update_Button: 'Update Prompt',

      // Results
      Results_Title: 'Results',
      Json_View_Title: 'Json View',
      Table_View_Title: 'Table View',
      Processing_Message: 'Processing your request...',
      Processing_Status: 'Current status: {{status}}',
      Copy_Success: 'Copied to clipboard!',
      Copy_Error: 'Failed to copy to clipboard',

      // Messages
      Success_Message: 'Prompt test completed successfully',
      Save_Success: 'Prompt saved successfully',
      Update_Success: 'Prompt updated successfully',
      Timeout_Message: 'Prompt test timed out after 5 minutes. Please try again later.',
      Error_Start_Test: 'Error starting prompt test',
      Error_Polling_Result: 'Error fetching prompt test result',
      Error_Unexpected_Response: 'Unexpected prompt test response',
      Error_No_Categories: 'Please select at least one menu category',
      Error_No_Restaurant: 'No restaurant selected',
      Error_No_Categories_Available: 'No menu categories available. Please create menu categories first.',
      Loading_Categories: 'Loading menu categories...',
      Error_Loading_Categories: 'Error loading menu categories:',

      // Validation messages
      Validation: {
        From_Date_Required: 'From date is required',
        To_Date_Required: 'To date is required',
        File_Required: 'File is required',
        File_Type_Error: 'Only PDF and image files are allowed',
        System_Prompt_Required: 'System prompt is required',
        User_Prompt_Required: 'User prompt is required',
        Model_Required: 'Model is required',
      },
    },
  },
};
